<template>
  <div class="container-sync">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">Manual Sync Management</div>
    </div>
    <div class="bg-white rounded-lg shadow p-3 flex gap-3 items-center">
      <div class="row">
        <div class="col-3">
          <multiselect
            :options="apis"
            v-model="selectedApi"
            :searchable="true"
            label="name"
            track-by="id"
            placeholder="Select Api"
            @select="onApiChange"
            :allowEmpty="false"
            :showLabels="false"
            :multiple="false"
          />
        </div>
        <div class="col-3">
          <multiselect
            :disabled="!isCinemaRequired"
            :options="cinemas"
            v-model="selectedCinema"
            @select="onSelectCinema"
            :searchable="true"
            label="cinema_name"
            track-by="cinema_id"
            placeholder="Select Cinema"
            :allowEmpty="false"
            :showLabels="false"
            :multiple="false"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="sync-card col-12 mb-2">
          <div class="row p-2">
            <div class="col-8">
              <div class="sync-card-header">
                <span class="method-badge method-post">{{ methodLabel }}</span>
                <div class="sync-url">
                  {{ maskedUrl(fullUrl) || "Select API" }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div v-if="selectedApi" class="sync-card-header-button">
                <button
                  class="sync-btn sync-btn-primary mr-1"
                  @click="sendRequest"
                  :disabled="loading"
                >
                  {{ loading ? "Sending..." : "Send" }}
                </button>
                <button
                  class="sync-btn sync-btn-secondary"
                  @click="cancelRequest"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex">
            <div class="w-50 mr-2">
              <div class="sync-section-label">Body</div>

              <textarea class="sync-textarea" v-model="payload"></textarea>
            </div>

            <div class="w-50">
              <div class="sync-section-label">
                Response
                <span class="sync-status status-success">{{ statusText }}</span>
              </div>

              <pre class="sync-response">
                  {{ response }}
                </pre
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      apis: [],
      cinemas: [],
      cinemaHosts: [],
      selectedApi: null,
      selectedCinema: null,
      payload: "{}",
      response: "",
      cancelToken: null,
      loading: false,
      statusCode: null,
    };
  },

  computed: {
    isCinemaRequired: function () {
      return this.selectedApi && this.selectedApi.is_cinema_specific === "Y";
    },

    methodLabel: function () {
      if (this.selectedApi && this.selectedApi.method)
        return this.selectedApi.method;
      return "POST";
    },

    fullUrl: function () {
      try {
        if (!this.selectedApi) return "";

        var endpoint = this.selectedApi.endpoint || "";
        var host = null;

        if (this.selectedApi.script_host_location === "CLOUD") {
          for (var i = 0; i < this.cinemaHosts.length; i++) {
            if (this.cinemaHosts[i].cinema_id === 0) {
              host = this.cinemaHosts[i];
              break;
            }
          }
        } else {
          if (!this.selectedCinema) return endpoint;

          for (var j = 0; j < this.cinemaHosts.length; j++) {
            if (
              this.cinemaHosts[j].cinema_id === this.selectedCinema.cinema_id
            ) {
              host = this.cinemaHosts[j];
              break;
            }
          }
        }

        if (host && host.cinema_url) {
          var cleanUrl = String(host.cinema_url).replace(/\"|,/g, "");
          return cleanUrl + endpoint;
        }

        return endpoint;
      } catch (err) {
        console.error("fullUrl error:", err);
        return "";
      }
    },

    statusText: function () {
      if (!this.statusCode) return "";
      return "Status: " + this.statusCode;
    },

    statusClass: function () {
      if (!this.statusCode) return "";
      if (this.statusCode >= 200 && this.statusCode < 300)
        return "text-green-600 text-xs";
      return "text-red-600 text-xs";
    },
  },

  mounted: function () {
    this.fetchData();
  },

  methods: {
    maskedUrl(url = "") {
      try {
        if (!url || typeof url !== "string") return "";

        const parts = url.split("/").filter(Boolean);

        if (parts.length === 0) return url;

        const firstPart = parts[0].slice(0, 4);
        const lastPart = parts[parts.length - 1];

        return `/${firstPart}.../${lastPart}`;
      } catch (err) {
        console.error("maskUrl error:", err);
        return "";
      }
    },
    onSelectCinema(cinema) {
      if (typeof this.payload == "string") {
        try {
          this.payload = JSON.parse(this.payload);
        } catch (err) {
          console.log("this.payload", this.payload);
        }
      }

      let tempPayload = this.payload;

      if (tempPayload && tempPayload.hasOwnProperty("cinema_id")) {
        console.log("inside this...");
        tempPayload = {
          ...tempPayload,
          cinema_id: cinema["cinema_id"],
        };
      }
      this.payload = JSON.stringify(tempPayload || {}, null, 2);
      console.log("this.payload", this.payload);
    },
    async fetchData() {
      MasterService.GetSyncApiLists()
        .then((response) => {
          const { data } = response;

          if (data.status) {
            this.apis = data.apisList || [];
            this.cinemas = data.cinemas || [];
            this.cinemaHosts = data.cinemaHosts || [];
          } else {
            this.apis = [];
            this.cinemas = [];
            this.cinemaHosts = [];
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },

    onApiChange: function () {
      if (!this.selectedApi) return;

      try {
        this.payload = JSON.stringify(this.selectedApi.payload || {}, null, 2);
      } catch (e) {
        this.payload = "{}";
      }

      this.selectedCinema = null;
      this.response = "";
      this.statusCode = null;
    },

    sendRequest: async function () {
      if (!this.selectedApi) {
        this.response = "Please select API";
        return;
      }

      if (this.isCinemaRequired && !this.selectedCinema) {
        this.response = "Cinema is required";
        return;
      }

      var body = {};
      try {
        body = this.payload ? JSON.parse(this.payload) : {};
      } catch (e) {
        this.response = "Invalid JSON payload";
        return;
      }

      if (this.isCinemaRequired && this.selectedCinema) {
        body.cinema_id = this.selectedCinema.cinema_id;
      }

      this.cancelToken = axios.CancelToken.source();
      this.loading = true;
      this.statusCode = null;

      try {
        var res = await axios({
          method: this.selectedApi.method,
          url: this.fullUrl,
          data: body,
          cancelToken: this.cancelToken.token,
        });

        this.statusCode = res.status;
        try {
          this.response = JSON.stringify(res.data, null, 2);
        } catch (e) {
          this.response = String(res.data);
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          this.response = "Request cancelled";
        } else if (err.response) {
          this.statusCode = err.response.status;
          try {
            this.response = JSON.stringify(err.response.data, null, 2);
          } catch (e) {
            this.response = String(err.response.data);
          }
        } else if (err.request) {
          this.response = "No response from server";
        } else {
          this.response = err.message || "Request failed";
        }
      } finally {
        this.loading = false;
      }
    },

    cancelRequest: function () {
      if (this.cancelToken) {
        this.cancelToken.cancel();
      }
    },
  },
};
</script>

<style>
/* Page */
body {
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* Container spacing */
.container-sync {
  /*max-width: 900px;*/
  margin: 20px auto;
}

/* Top controls */
.sync-toolbar {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Dropdowns */
.sync-select {
  height: 36px;
  font-size: 13px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}

/* Buttons */
.sync-btn {
  height: 36px;
  padding: 0 16px;
  font-size: 13px;
  border-radius: 4px;
}

.sync-btn-primary {
  background-color: #0d6efd;
  color: #fff;
  border: none;
}

.sync-btn-primary:hover {
  background-color: #0b5ed7;
}

.sync-btn-secondary {
  background-color: #e9ecef;
  border: none;
  color: #333;
}

/* Card (Postman style) */
.sync-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}

/* Header (method + URL) */
.sync-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-bottom: 1px solid #e5e7eb;
  /*background: #fafafa;*/
}

/* Method badge */
.method-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  text-transform: uppercase;
}

.method-post {
  background: #e7f1ff;
  color: #0d6efd;
}

.method-get {
  background: #e6f4ea;
  color: #198754;
}

.method-put {
  background: #fff3cd;
  color: #856404;
}

.method-delete {
  background: #f8d7da;
  color: #842029;
}

/* URL */
.sync-url {
  font-family: monospace;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Body label */
.sync-section-label {
  font-size: 12px;
  color: #6c757d;
  padding: 6px 12px;
  border-bottom: 1px solid #e5e7eb;
}

/* Textarea (Payload) */
.sync-textarea {
  background: #f9f9f9;
  color: #000000;
  width: 100%;
  height: 180px;
  border: none;
  border-radius: 10px;
  outline: none;
  padding: 12px;
  margin: 20px;
  font-family: monospace;
  font-size: 14px;
  resize: none;
}

/* Response box */
.sync-response {
  background: #f9f9f9;
  color: #000000;
  font-family: monospace;
  font-size: 14px;
  padding: 12px;
  margin: 20px;
  border-radius: 10px;
  height: 180px;
  overflow: auto;
}

/* Status text */
.sync-status {
  font-size: 12px;
  font-weight: 500;
}

.status-success {
  color: #198754;
}

.status-error {
  color: #dc3545;
}

.sync-card-header-button {
  padding-inline: 20px;
  justify-content: end;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GlobalOptionsComponents/syncManuallyPage.vue